import { render, staticRenderFns } from "./iconAlarm.vue?vue&type=template&id=17965f31&"
import script from "./iconAlarm.vue?vue&type=script&lang=js&"
export * from "./iconAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports